export default __webpack_public_path__ + "static/media/dashboardDryer.08b2e72b.png";